import { createSelector } from 'reselect';
import { RootState } from '../../../rootReducer';

const getStandardLoaded = (state: RootState) => !!state.annotation.annotationStandardDetails;
const getSelectedName = (state: RootState) => state.annotation.selectedName;
const getIsGettingAnnotations = (state: RootState) => state.annotation.isGettingAnnotations;

export const isGettingGridDataSelector = createSelector(
  [getStandardLoaded, getSelectedName, getIsGettingAnnotations],
  (standardLoaded, selectedName, isGettingAnnotations) => {
    if ((!standardLoaded && selectedName) || isGettingAnnotations) {
      return true;
    }

    return false;
  }
);
